import AuthImpl from '../../serviceImpl/AuthImpl';

const activateUserUseCase = async (uid: string, token: string): Promise<boolean> => {

  return AuthImpl.activateUser(uid, token)
    .then(() => Promise.resolve(true))
    .catch(() => Promise.resolve(false));
};

export default activateUserUseCase;